var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/wrench/components/actions/ButtonTeam.tsx",
  _this = this;
import React from 'react';
import { Button } from '@wds/button';
import { T, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
export var COPY = defineMessages({
  CREATE_TEAM: {
    id: 'ButtonTeam.createTeam',
    defaultMessage: 'Create team',
    description: '[Type: Label][Vis.: high] - This is the create team addon button on the header.'
  }
});
var ButtonTeam = function ButtonTeam() {
  return /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "upgrade",
    href: createURL('/billing/p2gupgrade/', {
      ut_source: 'header',
      ut_source3: 'webplat'
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.CREATE_TEAM,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }));
};
export default ButtonTeam;
//# sourceMappingURL=ButtonTeam.js.map